import { Button, Box, Grid } from "@mui/material"
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export const DownloadButton = ({setOpen}: {setOpen: Function}) => {
    return <Box component={'div'} width={'100%'} sx={{ backgroundColor: '#FFF' }}>
        <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button variant="text" endIcon={<PictureAsPdfIcon />} onClick={() => setOpen(true)}>Descargar Cotización</Button>
        </Grid>
    </Box>
}